export enum PaginationVariantEnum {
  defaultLight = 'defaultLight',
  pasha = 'pasha'
}

export interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isPashaLanding?: boolean;
  variant?: PaginationVariantEnum;
}
